import { combineReducers } from 'redux';
import itemsDataReducerFor from './common/itemsDataReducerFor';
import filtersReducerFor from './common/filtersReducerFor';
import statusReducerFor from './common/statusReducerFor';

const usersReducers = combineReducers({
  // usersData: usersDataReducer,
  usersData: itemsDataReducerFor('USERS_'),
  usersFilters: filtersReducerFor('USERS_'),
  usersStatus: statusReducerFor('USERS_'),
});

export default usersReducers;
